import React from 'react';
import ReactToPrint from 'react-to-print';

import Tippy from '@tippyjs/react';

import Button from 'components/shared/Buttons/Button';

const Header = ({ mode, ref, finalLoading, convertQuote = () => {} }) => {
  return (
    <>
      {mode.created && (
        <div className="flex w-full items-center justify-end">
          <ReactToPrint
            trigger={() => (
              <Button
                color=""
                size="small"
                type="link"
                text="Print"
                icon="printer-mono"
                className="text-primary-900"
              />
            )}
            content={() => ref.current}
          />

          {!mode?.converted && (
            <Tippy content="Convert to invoice" className="tippy-dark">
              <div className="relative">
                <Button
                  color=""
                  type="link"
                  size="small"
                  text="Convert"
                  loadingIcon={finalLoading}
                  icon="import-mono"
                  onClick={convertQuote}
                  data-qa="convert-to-invoice"
                  className="text-primary-900"
                />
              </div>
            </Tippy>
          )}
        </div>
      )}
    </>
  );
};

export default Header;
